module.exports = __webpack_public_path__ + "b57854a9b67218731dd5bcd0b273fac3.fbx";